// A product, dish or reel image, with a small bowl drawing as the fallback when there is none or
// it fails to load. "hero" renders nothing instead of a fallback.
import { useState } from 'preact/hooks';
import { thumbURL as thumbSrc } from '../api';

type Size = 'lg' | 'sm' | 'dish' | 'row' | 'card' | 'top' | 'hero';

export function Thumb({ src, name, size }: { src?: string; name: string; size: Size }) {
  const [broken, setBroken] = useState(false);
  const ok = !!src && (/^https:\/\//.test(src) || src.startsWith('/')) && !broken;
  if (size === 'hero' && !ok) return null;
  return (
    <span class={`thumb ${size}`} aria-hidden={ok ? undefined : 'true'}>
      {ok
        ? <img src={src} alt={name} loading="lazy" decoding="async" referrerpolicy="no-referrer" onError={() => setBroken(true)} />
        : <Bowl />}
    </span>
  );
}

/** The cover of a saved reel, only requested when the server has one. */
export function reelThumb(id: number, hasThumb?: boolean): string | undefined {
  return hasThumb ? thumbSrc(id) : undefined;
}

function Bowl() {
  return (
    <svg class="bowl" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M3 11h18a9 9 0 0 1-18 0z" /><path d="M9 7c0-1.5 1-2 1-3.5M13 7c0-1.5 1-2 1-3.5" /><path d="M8 20h8" />
    </svg>
  );
}
